import React, { useState, useRef, useGlobal, useEffect } from "reactn";
import axios from "axios";
import ToastCalendar from "@toast-ui/react-calendar";
import { toast } from "react-toastify";
import "tui-calendar/dist/tui-calendar.css";
import { Button } from "react-bootstrap";
import Select from "react-dropdown-select";
import "bootstrap/dist/css/bootstrap.min.css";
import AddAppointmentModal from "../../components/modals/AddAppointmentModal";

const TourAvailability = () => {
  const [events, setEvents] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newEvent, setNewEvent] = useState({
    start: null,
    end: null,
    type: "",
    location: []
  });
  const [view, setView] = useState("week");
  const calendarRef = useRef();
  const [global, setGlobal] = useGlobal();
  const [currentDate, setCurrentDate] = useState(new Date());

  const fetchInitialData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API}/partners/appointments/availability`
      );
      const availability = res.data.data ? res.data.data.availability : [];
      console.log("res", availability);
      setEvents(
        availability.map(item => ({
          id: item.id,
          start: new Date(item.start),
          end: new Date(item.end),
          type: item.type,
          location: item.location
        }))
      );
    } catch (error) {
      console.error("Error fetching availability data:", error);
    }
  };

  const save = async () => {
    let location = [];
    let type = [];
    events.map(e => {
      type.push(e.type);
      e.location.map(l => {
        location.push(l);
      });
    });
    location = [...new Set(location)];
    type = [...new Set(type)];
    console.log("Location and type sets:", location, type);
    try {
      const payload = {
        availability: JSON.stringify(events),
        location,
        type
      };
      let res = await axios.post(
        `${process.env.REACT_APP_API}/partners/appointments/availability`,
        payload
      );
      if (res.data.success) {
        // toast.success("Successfully Saved Availability");
      } else {
        toast.error("Failed to save Availability");
      }
    } catch (error) {
      console.error("Error saving event:", error);
    }
  };

  useEffect(() => {
    fetchInitialData();
    setGlobal({
      partnerPathway: [
        ...global.partnerPathway.slice(0, 1),
        { label: "Appointments", to: "/appointments" },
        { label: "Appointments Availability", to: "/appointments" }
      ]
    });
  }, []);

  useEffect(() => {
    if (events.length > 0) {
      save();
    }
  }, [events]);

  const handleTimeSlotClick = e => {
    const { start, end } = e;
    setNewEvent({
      edit: false,
      start: new Date(start),
      end: new Date(end),
      type: "",
      location: []
    });
    setShowModal(true);
  };

  const handleEventEdit = event => {
    console.log("editing event:", event);
    const { schedule } = event;
    console.log(schedule);
    setNewEvent({
      edit: true,
      id: schedule.id,
      start: new Date(schedule.start),
      end: new Date(schedule.end),
      type: schedule.title,
      location: schedule.location.split(",")
    });
    setShowModal(true);
  };

  const handleSaveEvent = () => {
    if (newEvent.type && newEvent.location.length > 0) {
      if (newEvent.edit) {
        setEvents(prevEvents =>
          prevEvents.map(evt =>
            evt.id === newEvent.id ? { ...evt, ...newEvent } : evt
          )
        );
        console.log(
          "Updated Events:",
          events.map(evt =>
            evt.id === newEvent.id ? { ...evt, ...newEvent } : evt
          )
        );
      } else {
        setEvents(prevEvents => [
          ...prevEvents,
          { id: Date.now(), ...newEvent }
        ]);
        console.log("Saved Events:", [
          ...events,
          { id: Date.now(), ...newEvent }
        ]);
      }
      setShowModal(false);
    } else {
      toast.error("Please fill in both Type and Location.");
    }
  };

  const handleViewChange = newView => {
    setView(newView);
    const calendarInstance = calendarRef.current.getInstance();
    calendarInstance.changeView(newView);
  };

  const handleNavigation = direction => {
    const calendarInstance = calendarRef.current.getInstance();
    if (direction === "prev") {
      calendarInstance.prev();
    } else if (direction === "next") {
      calendarInstance.next();
    } else {
      calendarInstance.today();
    }

    const newDate = calendarInstance.getDate().toDate();
    setCurrentDate(newDate);
  };

  const handleEventDrag = event => {
    const { schedule, changes } = event;
    console.log("Event Dragged:", schedule, changes);
    if (changes) {
      if (changes.start) changes.start = new Date(changes.start);
      if (changes.end) changes.end = new Date(changes.end);
      setEvents(prevEvents =>
        prevEvents.map(evt =>
          evt.id === schedule.id ? { ...evt, ...changes } : evt
        )
      );
    } else {
      handleEventEdit(event);
    }
  };

  const handleEventDelete = event => {
    const { schedule } = event;
    setEvents(prevEvents => prevEvents.filter(evt => evt.id !== schedule.id));
  };
  const getColour = event => {
    if (event.location.includes("Online")) return "rgba(126,160,255,1)";
    if (event.location.includes("In-Person")) return "rgba(245,198,140,1)";
    if (event.location.includes("Phone")) return "rgba(252,140,126,1)";
    return "rgba(126,160,255,1)";
  };

  return (
    <div
      className="cont"
      style={{
        width: "100%",
        maxWidth: "100%",
        margin: 0,
        padding: window.innerWidth < 768 ? "10px" : "20px",
        boxSizing: "border-box",
        position: window.innerWidth < 768 ? "relative" : "static",
        left: window.innerWidth < 768 ? "0" : "auto",
        right: window.innerWidth < 768 ? "0" : "auto"
      }}
    >
      <AddAppointmentModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onSave={handleSaveEvent}
        eventDetails={newEvent}
        allEvents={events}
        setEventDetails={setNewEvent}
      />
      <div
        className="row"
        style={{
          margin: 0,
          width: "100%",
          maxWidth: "100%"
        }}
      >
        <div
          className="col-md-6"
          style={{ padding: window.innerWidth < 768 ? "1px" : "15px" }}
        >
          <h1
            style={{
              fontSize: window.innerWidth < 768 ? "1.5rem" : "2rem"
            }}
          >
            Appointment Availability
          </h1>
        </div>
      </div>
      <div
        className="calendar-container"
        style={{
          backgroundColor: "#FFF",
          width: "100%",
          maxWidth: "100%",
          margin: 0,
          padding: 0,
          boxSizing: "border-box"
        }}
      >
        <div
          className="cal-menu d-flex justify-content-between"
          style={{
            marginBottom: window.innerWidth < 768 ? "8px" : "10px",
            backgroundColor: "#FFF",
            paddingTop: window.innerWidth < 768 ? "12px" : "15px"
          }}
        >
          <div>
            <button
              onClick={() => handleNavigation("prev")}
              className="btn btn-sm move-day"
              style={{
                marginRight: window.innerWidth < 768 ? "3px" : "5px",
                marginLeft: window.innerWidth < 768 ? "8px" : "10px",
                fontSize: window.innerWidth < 768 ? "0.8rem" : "1rem"
              }}
            >
              <i className="fas fa-arrow-left"></i>
            </button>
            <button
              onClick={() => handleNavigation("next")}
              className="btn btn-sm move-day"
              style={{
                marginRight: "5px",
                fontSize: "1rem",
                transform: `scale(${window.innerWidth < 768 ? 0.7 : 1})`,
                transformOrigin: "center"
              }}
            >
              <i className="fas fa-arrow-right"></i>
            </button>
            <button
              onClick={() => handleNavigation("today")}
              className="btn btn-outline-info btn-sm move-day"
              style={{
                marginRight: "5px",
                fontSize: "1rem",
                transform: `scale(${window.innerWidth < 768 ? 0.7 : 1})`,
                transformOrigin: "center"
              }}
            >
              Today
            </button>
          </div>
          <div
            className="current-month-year"
            style={{
              fontSize: window.innerWidth < 768 ? "1rem" : "1.2rem",
              fontWeight: "bold"
            }}
          >
            {currentDate.toLocaleString("default", {
              month: "long",
              year: "numeric"
            })}
            {/* {calendarRef.current?.getInstance().getDate().toDate()
              ? new Date(
                  calendarRef.current.getInstance().getDate().toDate()
                ).toLocaleString("default", { month: "long", year: "numeric" })
              : new Date().toLocaleString("default", {
                  month: "long",
                  year: "numeric"
                })} */}
          </div>
          <div
            className="view-switcher"
            style={{
              display: "flex",
              alignItems: "center",
              gap: window.innerWidth < 768 ? "2px" : "5px"
            }}
          >
            <button
              onClick={() => handleViewChange("day")}
              className="btn btn-outline-primary btn-sm"
              style={{
                marginRight: window.innerWidth < 768 ? "2px" : "5px",
                fontSize: "1rem",
                transform: `scale(${window.innerWidth < 768 ? 0.7 : 1})`,
                transformOrigin: "top left"
              }}
            >
              Day
            </button>
            <button
              onClick={() => handleViewChange("week")}
              className="btn btn-outline-primary btn-sm"
              style={{
                marginRight: window.innerWidth < 768 ? "2px" : "5px",
                fontSize: "1rem",
                transform: `scale(${window.innerWidth < 768 ? 0.7 : 1})`,
                transformOrigin: "top left"
              }}
            >
              Week
            </button>
            <button
              onClick={() => handleViewChange("month")}
              className="btn btn-outline-primary btn-sm"
              style={{
                marginRight: window.innerWidth < 768 ? "2px" : "5px",
                fontSize: "1rem",
                transform: `scale(${window.innerWidth < 768 ? 0.7 : 1})`,
                transformOrigin: "top left"
              }}
            >
              Month
            </button>
          </div>
        </div>
        <ToastCalendar
          style={{
            transform: `scale(${window.innerWidth < 768 ? 0.7 : 1})`,
            transformOrigin: "top left"
          }}
          ref={calendarRef}
          usageStatistics={false}
          taskView={false}
          scheduleView={["time"]}
          view={view}
          height={window.innerWidth < 768 ? "80%" : "100%"}
          calendars={[
            {
              id: "1",
              name: "time"
            }
          ]}
          disableDblClick={true}
          disableClick={false}
          isReadOnly={false}
          useDetailPopup={true}
          onClickTimezonesCollapse={() => {}}
          onBeforeCreateSchedule={handleTimeSlotClick}
          onBeforeUpdateSchedule={handleEventDrag}
          onBeforeDeleteSchedule={handleEventDelete}
          onBeforeEditSchedule={handleEventEdit}
          week={{
            hourStart: 0,
            hourEnd: 24,
            scrollToNow: true
          }}
          schedules={events.map(event => ({
            id: event.id,
            calendarId: "1",
            title: event.type,
            location: event.location.join(","),
            category: "time",
            start: new Date(event.start),
            end: new Date(event.end),
            bgColor: getColour(event),
            borderColor: getColour(event),
            dragBgColor: getColour(event)
            // background: getColour(event)
          }))}
          template={{
            time: schedule => `<span>${schedule.title}</span>`
          }}
        />
      </div>
    </div>
  );
};

export default TourAvailability;
